import { DisplayMode } from '@amzn/ihm-floorplan-core';
import Select, { SelectOption } from '@amzn/meridian/select';
import { SelectWidth } from '@amzn/meridian/select/select';
import React from 'react';

interface DisplayModeSelectorProps {
  displayModes: DisplayMode[];
  selectedDisplayMode: DisplayMode;
  setSelectedDisplayMode: (displayMode: DisplayMode) => void;
  width?: SelectWidth;
}

const DisplayModeSelector = ({
  displayModes,
  selectedDisplayMode,
  setSelectedDisplayMode,
  width,
}: DisplayModeSelectorProps): JSX.Element => (
  <Select
    label="Display Mode"
    value={selectedDisplayMode.id}
    onChange={(displayModeId: string) => {
      const foundDisplayMode = displayModes.find((dm: { id: string }) => dm.id === displayModeId);
      if (foundDisplayMode) {
        setSelectedDisplayMode(foundDisplayMode);
      }
    }}
    placeholder="Select display mode"
    width={width ?? 300}
    size="small"
  >
    {displayModes.map((dm) => (
      <SelectOption key={dm.id} value={dm.id} label={dm.name} />
    ))}
  </Select>
);

export default DisplayModeSelector;
